import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Image,
  Text,
  Spacer,
  Button,
  VStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { actionAccessMain, formatDate_Do_MMM_YYYY_Time, getBranchId, getHospitalId, getIsDoctor, getLoginID } from "../../auth";
import {
  UpdateAppointmentByDoctor,
  CreateAppointmentByDoctor,
} from "../../middleware/services/visits";
import DynamicModal from "../dynamic-modal";
import { useNavigate, useLocation } from "react-router-dom";
import { GetPatientHealthData, saveAppointmentNotification, UpdateAppointmentStatus } from "../../middleware/services/visits/patient-overview";
import PrimaryButton from "../primary-button";
import moment from "moment";
import { GetDoctorSlots } from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import DatePicker from "../date-picker";
import { COLORS } from "../styles/colors";
import Toaster from "../toaster";
import Loader from "../loader/loader";
import useLoader from "../loader/loaderstates";
import { AcceptVisit, FetchDoctorsByUser } from "../../middleware/services/home";
import DropdownInput from "../dropdown-input";
import AssignVisit from "../assignVisit";
import AssignVisitLogs from "../assignVisitlogs";

const PatientVisitCard = ({
  userImage,
  userName,
  visitDate,
  doctorName,
  patientFcm,
  isUpcoming = false,
  visitTime,
  issue,
  borderColor,
  bgColor,
  disableLeftBorder = false,
  patientId,
  appointmentId,
  appointmentStatus,
  // fetchCalendarData,
  // fetchSidePanelData,
  refreshPageContent,
  visitStatus,
  statusName,
  isAssign,
  isAssignStatus,
  prescriptionUrl,
  imagePath
}) => {

  useEffect(() => {
    // console.log("doctorName", doctorName)
    // console.log("userName", userName)
    // console.log("visitDate", visitDate)
    // console.log("visitTime", visitTime)
    // console.log("appointmentStatus", appointmentStatus)
    // console.log("refreshPageContent", refreshPageContent)
    // console.log("visitStatus",visitStatus)
    // console.log("statusName", statusName)
    // console.log("isAssign", isAssign)
    // console.log("isAssignStatus", isAssignStatus)


    console.log("prescriptionUrl", prescriptionUrl)
    console.log("imagePath", imagePath)
  }, [])
  const { showSuccessToast, showErrorToast } = Toaster();

  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [showOptions, setShowOptions] = useState(false);
  const optionsRef = useRef();
  const svgRef = useRef();

  const doctorId = getLoginID();
  const navigate = useNavigate();

  const startVisit = useRef();
  const acceptVisit = useRef();
  const cancelVisit = useRef();
  const rescheduleVisit = useRef();
  const scheduleVisit = useRef();
  const noShowVisit = useRef();

  let isNotUpcoming = false;
  let isFinished = false;
  function formatgender(value) {
    if (typeof value !== "string") {
      return value; // Return the value as is if it's not a string
    }

    switch (value.toLowerCase()) { // Optional: Make it case-insensitive
      case "female":
        return 1;
      case "male":
        return 2;
      case "other":
        return 3;
      default:
        return 2; // Default value for unexpected strings
    }
  }

  const formatDOBDate = (date) => {
    // Check if the date is already in YYYY-MM-DD format
    if (moment(date, "YYYY-MM-DD", true).isValid()) {
      return date;
    }
    // If not, assume it's in DD-MM-YYYY format and convert it to YYYY-MM-DD
    return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
  };

  function calculateAge(dob) {
    // Check if dob is valid
    if (!dob || isNaN(new Date(dob).getTime())) {
      return ""; // Return empty if dob is invalid
    }
  
    const dobDate = new Date(dob);
    const today = new Date();
  
    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDifference = today.getMonth() - dobDate.getMonth();
    const dayDifference = today.getDate() - dobDate.getDate();
  
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }
  
    return age;
  }
  


  // console.log(appointmentStatus);
  const handleCreateVisitClick = async () => {
    const getPatientInfo = async () => {
      showLoader();
      try {
        const result = await GetPatientHealthData({
          patientid: patientId,
          doctorid: doctorId,
        });
        return result; // Return the fetched result
      } catch (error) {
        console.error("Error in fetching patient info:", error);
        return null; // Return null in case of an error
      } finally {
        dismissLoader();
      }
    };
  
    // Fetch patient info
    const patientInfo = await getPatientInfo();
  
    if (!patientInfo || !patientInfo.patientinfo) {
      console.error("Patient information not available.");
      return; // Stop execution if patient info is not fetched
    }
  
    // Create the input to save
    const inputToSave = {
      input: {
        firstname: patientInfo.patientinfo?.firstname,
        lastname: patientInfo.patientinfo?.lastname,
        fullname: patientInfo.patientinfo?.firstname + " " + patientInfo.patientinfo?.lastname,
        gender: patientInfo.patientinfo?.gender ? formatgender(patientInfo.patientinfo?.gender) : 2,
        dob: patientInfo.patientinfo?.dob ? formatDOBDate(patientInfo.patientinfo?.dob) : null,
        age: patientInfo.patientinfo?.dob ? calculateAge(patientInfo.patientinfo.dob) : null,
        mobileno: patientInfo.patientinfo?.mobileno || null,
        email: patientInfo.patientinfo?.email || null,
        countryid: patientInfo.patientinfo?.countryid || "",
        countrycode: patientInfo.patientinfo?.countrycode || "",
        doctorid: doctorId,
        patientid: patientId,
      },
    };
  
    // Navigate to advanced details
    navigate("/advancedetails", {
      state: {
        input: inputToSave.input,
        patientid: patientId,
        appointmentid: appointmentId,
      },
    });
  };
  

  if (appointmentStatus !== 1 && appointmentStatus !== 0) {
    isNotUpcoming = true;
  } else {
    isNotUpcoming = false;
  }

  if (appointmentStatus === 3) {
    isFinished = true;
  } else {
    isFinished = false;
  }

  const [appointmentRescheduleDate, setAppointmentRescheduleDate] = useState(
    new Date()
  );
  const [appointmentRescheduleTime, setAppointmentRescheduleTime] =
    useState(null);

  const [availableSlots, setAvailableSlots] = useState([]);

  const [actionAccess, setActionAccess] = useState(null);
  const [actionAccessAppointments, setActionAccessAppointments] = useState(null);

  const [actionAccessMessage, setActionAccessMessage] = useState(null);
  const [actionAccessScreening, setActionAccessScreening] = useState(null);
  const [actionAccessAssigning, setActionAccessAssigning] = useState(null);
  const fetchDoctorSlots = async (dateToReSchedule) => {
    // console.log(dateToReSchedule);
    const inputToFetch = {
      input: {
        doctorid: doctorId,
        date: dateToReSchedule
          ? moment(dateToReSchedule, "DD-MM-YYYY").format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
      },
    };
    // console.log(inputToFetch);
    // console.log("input send: ", patientId, dateToReSchedule);
    showLoader();
    try {
      const data = await GetDoctorSlots(inputToFetch.input);

      // console.log("Output", data);
      const slots = data?.output?.data || [];
      const currentDate = moment().format("DD-MM-YYYY");
      function isDateInCorrectFormat(dateStr) {
        const regex = /^\d{2}-\d{2}-\d{4}$/;
        return regex.test(dateStr);
      }

      const formattedRescheduleDate = isDateInCorrectFormat(dateToReSchedule)
        ? dateToReSchedule
        : moment(dateToReSchedule).format("DD-MM-YYYY");
      // console.log("Date to reschedule", dateToReSchedule);
      // console.log("Formated reschedule", formattedRescheduleDate);
      // console.log("current date", currentDate);
      if (dateToReSchedule && formattedRescheduleDate === currentDate) {
        // console.log(dateToReSchedule);
        // console.log(currentDate);
        const currentTime = new Date();
        const currentHours = currentTime.getHours();
        const currentMinutes = currentTime.getMinutes();
        const filteredSlots = slots.filter((slot) => {
          const [slotHours, slotMinutes] = slot.starttime
            .split(":")
            .map(Number);
          return (
            slotHours > currentHours ||
            (slotHours === currentHours && slotMinutes >= currentMinutes)
          );
        });
        // console.log(filteredSlots.length);
        // console.log(filteredSlots);
        // console.log(slots.length);
        setAvailableSlots(slots);
      }
      // console.log("New Slots: ", slots);
      else {
        // console.log("Other case");
        setAvailableSlots(slots);
      }
    } catch (error) {
      console.error("Error fetching Doctor Slots data:", error);
    } finally {
      dismissLoader();
    }
  };

  // useEffect(() => {
  //   console.log()
  //   fetchDoctorSlots();
  // }, [appointmentRescheduleDate]);

  const [timePeriod, setTimePeriod] = useState("Morning");

  const NewSlotSelector = ({ availableSlots }) => {
    const [selectedSlot, setSelectedSlot] = useState(null);
    const currentDate = moment().format("DD-MM-YYYY");
    const currentTime = new Date();

    const isSlotDisabled = (slot) => {
      const slotTime = new Date(`1970-01-01T${slot.starttime}`);
      const slotDate = moment(appointmentRescheduleDate).format("DD-MM-YYYY");

      function isDateInCorrectFormat(dateStr) {
        const regex = /^\d{2}-\d{2}-\d{4}$/;
        return regex.test(dateStr);
      }

      const formattedRescheduleDate = isDateInCorrectFormat(
        appointmentRescheduleDate
      )
        ? appointmentRescheduleDate
        : moment(appointmentRescheduleDate).format("DD-MM-YYYY");
      if (
        appointmentRescheduleDate &&
        formattedRescheduleDate === currentDate
      ) {
        // console.log("Same day events")

      // If the slot is for today and its time has passed, disable it
      
        const currentHours = currentTime.getHours();
        const currentMinutes = currentTime.getMinutes();
        const [slotHours, slotMinutes] = slot.starttime.split(":").map(Number);

        return (
          slotHours < currentHours ||
          (slotHours === currentHours && slotMinutes < currentMinutes)
        );
      }

      // If it's not today, don't disable
      return false;
    };

    const timePeriods = ["Morning", "Afternoon", "Evening", "Night"];
    const timePeriodSlots = {
      Morning: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T09:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T12:00:00")
      ),
      Afternoon: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T12:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T18:00:00")
      ),
      Evening: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T18:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T21:00:00")
      ),
      Night: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
          new Date("1970-01-01T21:00:00")
      ),
    };

    const handleTimePeriodChange = (direction) => {
      const currentIndex = timePeriods.indexOf(timePeriod);
      const newIndex =
        (currentIndex + direction + timePeriods.length) % timePeriods.length;
      setTimePeriod(timePeriods[newIndex]);
    };

    const handleSlotSelection = (slot) => {
      if (!isSlotDisabled(slot)) {
        // console.log("Selection made")
        setSelectedSlot(slot.starttime);
        setAppointmentRescheduleTime(slot.starttime);
        const selectedTime = new Date(`1970-01-01T${slot.starttime}`);
        if (
          selectedTime >= new Date("1970-01-01T09:00:00") &&
          selectedTime < new Date("1970-01-01T12:00:00")
        ) {
          setTimePeriod("Morning");
        } else if (
          selectedTime >= new Date("1970-01-01T12:00:00") &&
          selectedTime < new Date("1970-01-01T18:00:00")
        ) {
          setTimePeriod("Afternoon");
        } else if (
          selectedTime >= new Date("1970-01-01T18:00:00") &&
          selectedTime < new Date("1970-01-01T21:00:00")
        ) {
          setTimePeriod("Evening");
        } else {
          setTimePeriod("Night");
        }
        // console.log(timePeriod);
      }
    };

    return (
      <Box>
        {isLoading && <Loader miniLoader={true} />}
        {!isLoading && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={4}
            >
              <Box as="button" onClick={() => handleTimePeriodChange(-1)}>
                <Image src="/assets/svgs/left-tab-icon.svg" />
              </Box>
              <Text fontSize="xl" fontWeight="bold">
                {timePeriod}
                <Text fontSize="md" color="gray" display={"inline"} ml={"8px"}>
                  {timePeriodSlots[timePeriod].length} slots
                </Text>
              </Text>
              <Box as="button" onClick={() => handleTimePeriodChange(1)}>
                <Image src="/assets/svgs/right-tab-icon.svg" />
              </Box>
            </Box>

            <SimpleGrid columns={5} spacing={4}>
              {timePeriodSlots[timePeriod].map((slot) => (
                <Box
                  key={slot.starttime}
                  as="button"
                  onClick={() => handleSlotSelection(slot)}
                  borderWidth="1px"
                  borderRadius="md"
                  p={2}
                  textAlign="center"
                  bg={
                    appointmentRescheduleTime === slot.starttime
                      ? "blue.500"
                      : isSlotDisabled(slot)
                      ? "gray.300"
                      : "white"
                  }
                  color={appointmentRescheduleTime === slot.starttime ? "white" : "black"}
                  borderColor={
                    appointmentRescheduleTime === slot.starttime ? "blue.500" : "gray.300"
                  }
                  _hover={{
                    bg:
                    appointmentRescheduleTime === slot.starttime
                        ? "blue.600"
                        : isSlotDisabled(slot)
                        ? "gray.300"
                        : "gray.200",
                  }}
                  disabled={isSlotDisabled(slot)}
                >
                  {slot.starttime.substring(0, 5)}
                </Box>
              ))}
            </SimpleGrid>
          </>
        )}
      </Box>
    );
  };

  const SlotSelector = ({ availableSlots }) => {
    // console.log(moment(new Date()).format("DD-MM-YYYY"));
    const [selectedSlot, setSelectedSlot] = useState(null);

    const timePeriods = ["Morning", "Afternoon", "Evening", "Night"];
    const timePeriodSlots = {
      Morning: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T09:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T12:00:00")
      ),
      Afternoon: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T12:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T18:00:00")
      ),
      Evening: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T18:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T21:00:00")
      ),
      Night: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
          new Date("1970-01-01T21:00:00")
      ),
    };

    const handleTimePeriodChange = (direction) => {
      const currentIndex = timePeriods.indexOf(timePeriod);
      const newIndex =
        (currentIndex + direction + timePeriods.length) % timePeriods.length;
      setTimePeriod(timePeriods[newIndex]);
    };

    const handleSlotSelection = (slot) => {
      setAppointmentRescheduleTime(slot.starttime);
      const selectedTime = new Date(`1970-01-01T${slot.starttime}`);
      if (
        selectedTime >= new Date("1970-01-01T09:00:00") &&
        selectedTime < new Date("1970-01-01T12:00:00")
      ) {
        setTimePeriod("Morning");
      } else if (
        selectedTime >= new Date("1970-01-01T12:00:00") &&
        selectedTime < new Date("1970-01-01T18:00:00")
      ) {
        setTimePeriod("Afternoon");
      } else if (
        selectedTime >= new Date("1970-01-01T18:00:00") &&
        selectedTime < new Date("1970-01-01T21:00:00")
      ) {
        setTimePeriod("Evening");
      } else {
        setTimePeriod("Night");
      }
      // console.log(timePeriod);
    };

    return (
      <Box>
        {isLoading && <Loader miniLoader={true} />}

        {!isLoading && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={4}
            >
              <Box as="button" onClick={() => handleTimePeriodChange(-1)}>
                <Image src="/assets/svgs/left-tab-icon.svg" />
              </Box>
              <Text fontSize="xl" fontWeight="bold">
                {timePeriod}
                <Text fontSize="md" color="gray" display={"inline"} ml={"8px"}>
                  {timePeriodSlots[timePeriod].length} slots{" "}
                </Text>
              </Text>
              <Box as="button" onClick={() => handleTimePeriodChange(1)}>
                <Image src="/assets/svgs/right-tab-icon.svg" />
              </Box>
            </Box>

            <SimpleGrid columns={5} spacing={4}>
              {timePeriodSlots[timePeriod].map((slot) => (
                <Box
                  key={slot.starttime}
                  as="button"
                  onClick={() => handleSlotSelection(slot)}
                  borderWidth="1px"
                  borderRadius="md"
                  p={2}
                  textAlign="center"
                  bg={
                    appointmentRescheduleTime === slot.starttime
                      ? "blue.500"
                      : "white"
                  }
                  color={
                    appointmentRescheduleTime === slot.starttime
                      ? "white"
                      : "black"
                  }
                  borderColor={
                    appointmentRescheduleTime === slot.starttime
                      ? "blue.500"
                      : "gray.300"
                  }
                  _hover={{
                    bg:
                      appointmentRescheduleTime === slot.starttime
                        ? "blue.600"
                        : "gray.200",
                  }}
                >
                  {slot.starttime.substring(0, 5)}
                </Box>
              ))}
            </SimpleGrid>
          </>
        )}
      </Box>
    );
  };

  const [appointmentScheduleDate, setAppointmentScheduleDate] = useState(
    new Date()
  );
  const [appointmentScheduleTime, setAppointmentScheduleTime] = useState(null);

  const fetchDoctorScheduleSlots = async (dateToSchedule) => {
    // console.log(dateToSchedule);
    const inputToFetch = {
      input: {
        doctorid: doctorId,
        date: dateToSchedule
          ? moment(dateToSchedule, "DD-MM-YYYY").format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
      },
    };
    // console.log(inputToFetch);
    showLoader();
    try {
      // console.log("Request send for", patientId, dateToSchedule);
      const data = await GetDoctorSlots(inputToFetch.input);
      // console.log("response recieved", data);
      const slots = data?.output?.data || [];
      const currentDate = moment().format("DD-MM-YYYY");

      function isDateInCorrectFormat(dateStr) {
        const regex = /^\d{2}-\d{2}-\d{4}$/;
        return regex.test(dateStr);
      }

      const formattedScheduleDate = isDateInCorrectFormat(dateToSchedule)
        ? dateToSchedule
        : moment(dateToSchedule).format("DD-MM-YYYY");
      if (dateToSchedule && formattedScheduleDate === currentDate) {
        // console.log(appointmentScheduleDate);
        // console.log(currentDate);
        const currentTime = new Date();
        const currentHours = currentTime.getHours();
        const currentMinutes = currentTime.getMinutes();
        const filteredSlots = slots.filter((slot) => {
          const [slotHours, slotMinutes] = slot.starttime
            .split(":")
            .map(Number);
          return (
            slotHours > currentHours ||
            (slotHours === currentHours && slotMinutes >= currentMinutes)
          );
        });
        // console.log(filteredSlots.length);
        // console.log(slots.length);
        setAvailableSlots(slots);
      }
      // console.log("New Slots: ", slots);
      else {
        // console.log("Other case");
        setAvailableSlots(slots);
      }
    } catch (error) {
      console.error("Error fetching Doctor Slots data:", error);
    } finally {
      dismissLoader();
    }
  };

  // useEffect(() => {
  //   fetchDoctorScheduleSlots();
  // }, [appointmentScheduleDate, scheduleVisit.current.openModal]);

  const NewScheduleSlotSelector = ({ availableSlots }) => {
    const [selectedSlot, setSelectedSlot] = useState(null);
    const currentDate = moment().format("DD-MM-YYYY");
    const currentTime = new Date();

    const isSlotDisabled = (slot) => {
      const slotTime = new Date(`1970-01-01T${slot.starttime}`);
      const slotDate = moment(appointmentScheduleDate).format("DD-MM-YYYY");

      function isDateInCorrectFormat(dateStr) {
        const regex = /^\d{2}-\d{2}-\d{4}$/;
        return regex.test(dateStr);
      }

      const formattedScheduleDate = isDateInCorrectFormat(
        appointmentScheduleDate
      )
        ? appointmentScheduleDate
        : moment(appointmentScheduleDate).format("DD-MM-YYYY");
      if (
        appointmentScheduleDate &&
        formattedScheduleDate === currentDate
      ) {
        // console.log("Same day events")

      // If the slot is for today and its time has passed, disable it
      
        const currentHours = currentTime.getHours();
        const currentMinutes = currentTime.getMinutes();
        const [slotHours, slotMinutes] = slot.starttime.split(":").map(Number);

        return (
          slotHours < currentHours ||
          (slotHours === currentHours && slotMinutes < currentMinutes)
        );
      }

      // If it's not today, don't disable
      return false;
    };

    const timePeriods = ["Morning", "Afternoon", "Evening", "Night"];
    const timePeriodSlots = {
      Morning: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T09:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T12:00:00")
      ),
      Afternoon: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T12:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T18:00:00")
      ),
      Evening: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T18:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T21:00:00")
      ),
      Night: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
          new Date("1970-01-01T21:00:00")
      ),
    };

    const handleTimePeriodChange = (direction) => {
      const currentIndex = timePeriods.indexOf(timePeriod);
      const newIndex =
        (currentIndex + direction + timePeriods.length) % timePeriods.length;
      setTimePeriod(timePeriods[newIndex]);
    };

    const handleSlotSelection = (slot) => {
      if (!isSlotDisabled(slot)) {
        // console.log("Selection made")
        setSelectedSlot(slot.starttime);
        setAppointmentScheduleTime(slot.starttime);
        const selectedTime = new Date(`1970-01-01T${slot.starttime}`);
        if (
          selectedTime >= new Date("1970-01-01T09:00:00") &&
          selectedTime < new Date("1970-01-01T12:00:00")
        ) {
          setTimePeriod("Morning");
        } else if (
          selectedTime >= new Date("1970-01-01T12:00:00") &&
          selectedTime < new Date("1970-01-01T18:00:00")
        ) {
          setTimePeriod("Afternoon");
        } else if (
          selectedTime >= new Date("1970-01-01T18:00:00") &&
          selectedTime < new Date("1970-01-01T21:00:00")
        ) {
          setTimePeriod("Evening");
        } else {
          setTimePeriod("Night");
        }
        // console.log(timePeriod);
      }
    };

    return (
      <Box>
        {isLoading && <Loader miniLoader={true} />}
        {!isLoading && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={4}
            >
              <Box as="button" onClick={() => handleTimePeriodChange(-1)}>
                <Image src="/assets/svgs/left-tab-icon.svg" />
              </Box>
              <Text fontSize="xl" fontWeight="bold">
                {timePeriod}
                <Text fontSize="md" color="gray" display={"inline"} ml={"8px"}>
                  {timePeriodSlots[timePeriod].length} slots
                </Text>
              </Text>
              <Box as="button" onClick={() => handleTimePeriodChange(1)}>
                <Image src="/assets/svgs/right-tab-icon.svg" />
              </Box>
            </Box>

            <SimpleGrid columns={5} spacing={4}>
              {timePeriodSlots[timePeriod].map((slot) => (
                <Box
                  key={slot.starttime}
                  as="button"
                  onClick={() => handleSlotSelection(slot)}
                  borderWidth="1px"
                  borderRadius="md"
                  p={2}
                  textAlign="center"
                  bg={
                    appointmentScheduleTime === slot.starttime
                      ? "blue.500"
                      : isSlotDisabled(slot)
                      ? "gray.300"
                      : "white"
                  }
                  color={appointmentScheduleTime === slot.starttime ? "white" : "black"}
                  borderColor={
                    appointmentScheduleTime === slot.starttime ? "blue.500" : "gray.300"
                  }
                  _hover={{
                    bg:
                    appointmentScheduleTime === slot.starttime
                        ? "blue.600"
                        : isSlotDisabled(slot)
                        ? "gray.300"
                        : "gray.200",
                  }}
                  disabled={isSlotDisabled(slot)}
                >
                  {slot.starttime.substring(0, 5)}
                </Box>
              ))}
            </SimpleGrid>
          </>
        )}
      </Box>
    );
  };

  const ScheduleSlotSelector = ({ availableSlots }) => {
    const [selectedSlot, setSelectedSlot] = useState(null);

    const timePeriods = ["Morning", "Afternoon", "Evening", "Night"];
    const timePeriodSlots = {
      Morning: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T09:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T12:00:00")
      ),
      Afternoon: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T12:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T18:00:00")
      ),
      Evening: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
            new Date("1970-01-01T18:00:00") &&
          new Date(`1970-01-01T${slot.starttime}`) <
            new Date("1970-01-01T21:00:00")
      ),
      Night: availableSlots.filter(
        (slot) =>
          new Date(`1970-01-01T${slot.starttime}`) >=
          new Date("1970-01-01T21:00:00")
      ),
    };

    const handleTimePeriodChange = (direction) => {
      const currentIndex = timePeriods.indexOf(timePeriod);
      const newIndex =
        (currentIndex + direction + timePeriods.length) % timePeriods.length;
      setTimePeriod(timePeriods[newIndex]);
    };

    const handleSlotSelection = (slot) => {
      // console.log("clicked");
      setAppointmentScheduleTime(slot.starttime);
      const selectedTime = new Date(`1970-01-01T${slot.starttime}`);
      if (
        selectedTime >= new Date("1970-01-01T09:00:00") &&
        selectedTime < new Date("1970-01-01T12:00:00")
      ) {
        setTimePeriod("Morning");
      } else if (
        selectedTime >= new Date("1970-01-01T12:00:00") &&
        selectedTime < new Date("1970-01-01T18:00:00")
      ) {
        setTimePeriod("Afternoon");
      } else if (
        selectedTime >= new Date("1970-01-01T18:00:00") &&
        selectedTime < new Date("1970-01-01T21:00:00")
      ) {
        setTimePeriod("Evening");
      } else {
        setTimePeriod("Night");
      }
      // console.log(timePeriod);
    };

    return (
      <Box>
        {isLoading && <Loader miniLoader={true} />}

        {!isLoading && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={4}
            >
              <Box as="button" onClick={() => handleTimePeriodChange(-1)}>
                <Image src="/assets/svgs/left-tab-icon.svg" />
              </Box>
              <Text fontSize="xl" fontWeight="bold">
                {timePeriod}
                <Text fontSize="md" color="gray" display={"inline"} ml={"8px"}>
                  {timePeriodSlots[timePeriod].length} slots{" "}
                </Text>
              </Text>
              <Box as="button" onClick={() => handleTimePeriodChange(1)}>
                <Image src="/assets/svgs/right-tab-icon.svg" />
              </Box>
            </Box>

            <SimpleGrid columns={5} spacing={4}>
              {timePeriodSlots[timePeriod].map((slot) => (
                <Box
                  key={slot.starttime}
                  as="button"
                  onClick={() => handleSlotSelection(slot)}
                  borderWidth="1px"
                  borderRadius="md"
                  p={2}
                  textAlign="center"
                  bg={
                    appointmentScheduleTime === slot.starttime
                      ? "blue.500"
                      : "white"
                  }
                  color={
                    appointmentScheduleTime === slot.starttime
                      ? "white"
                      : "black"
                  }
                  borderColor={
                    appointmentScheduleTime === slot.starttime
                      ? "blue.500"
                      : "gray.300"
                  }
                  _hover={{
                    bg:
                      appointmentScheduleTime === slot.starttime
                        ? "blue.600"
                        : "gray.200",
                  }}
                >
                  {slot.starttime.substring(0, 5)}
                </Box>
              ))}
            </SimpleGrid>
          </>
        )}
      </Box>
    );
  };

  const openScheduleModal = async () => {
    // console.log("function called", availableSlots);
    setShowOptions(!showOptions); // Important to close the options panel before opening up the modal
    setAvailableSlots([]);
    setTimePeriod("Morning");
    setAppointmentScheduleTime(null);
    setAppointmentScheduleDate(new Date());
    fetchDoctorScheduleSlots(moment().format("DD-MM-YYYY"));
    scheduleVisit.current.openModal();
  };

  const handleScheduleClick = async () => {
    if (!appointmentScheduleTime) {
      showErrorToast("Please select a slot before scheduling");
    } else {
      const inputToSave = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentdate: moment(appointmentScheduleDate).format("YYYY-MM-DD"),
          appointmenttime: appointmentScheduleTime.substring(0, 5),
          // appointmentfor: "for general checkup",
          appointmenttype_cd: 693,
          client_secret: "",
          paymenttype: "cash",
          activeuserid: null,
          isdoctorcreated: 1,
        },
      };

      // console.log(inputToSave);
      try {
        const result = await CreateAppointmentByDoctor(inputToSave.input);
        console.log(result);
        if (result) {
          scheduleVisit.current.closeModal();
          refreshPageContent();
          showSuccessToast("Visit scheduled successfully");
          // navigate(`/visits`);
        }
      } catch (error) {
        console.error("Error in create visit:", error);
        showErrorToast("Error Happened While Saving.");
      }
    }
  };

  const openRescheduleModal = async () => {
    // console.log("function called", availableSlots);
    setShowOptions(!showOptions); // Important to close the options panel before opening up the modal
    setAvailableSlots([]);
    setTimePeriod("Morning");
    setAppointmentRescheduleTime(null);
    setAppointmentRescheduleDate(new Date());
    fetchDoctorSlots(moment().format("DD-MM-YYYY"));
    rescheduleVisit.current.openModal();
  };

  const handleRescheduleClick = async () => {
    if (!appointmentRescheduleTime) {
      showErrorToast("Please select a slot before rescheduling");
    } else {
      const inputToSave = {
        input: {
          patientid: patientId,
          doctorid: doctorId,
          appointmentdate: moment(appointmentRescheduleDate).format(
            "YYYY-MM-DD"
          ),
          appointmenttime: appointmentRescheduleTime.substring(0, 5),
          // appointmentfor: "Follow-up consultation",
          familyid: null,
          appointmentid: appointmentId,
          reason: "Scheduling conflict",
          type: "reschedule",
        },
      };

      showLoader();
      try {
        const result = await UpdateAppointmentByDoctor(inputToSave.input);
        // console.log("output", result);
        if (result) {
          rescheduleVisit.current.closeModal();
          refreshPageContent();
          showSuccessToast("Visit rescheduled successfully");
          // navigate(`/visits`);
          dismissLoader();
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in create visit:", error);
        showErrorToast("Error Happened While Saving.");
      }
    }
  };

  const handleConfirmStart = async () => {
    const inputForStart = {
      input: {
        doctorid: doctorId,
        appointmentid: appointmentId,
        type: "start",
        time: new Date().toISOString(),
      },
    };
    try {
      const result = await UpdateAppointmentStatus(inputForStart.input);
      startVisit.current.closeModal();
      navigate(
        `/quickvisit?doctorId=${doctorId}&patientId=${patientId}&appointmentId=${appointmentId}`
      );
      // navigate(
      //   `/startvisit?doctorId=${doctorId}&patientId=${patientId}&appointmentId=${appointmentId}`
      // );
    } catch (error) {
      console.error("Error updating appointment status:", error);
    }
  };

  function formatInputDate(inputDate) {
  // Remove ordinal indicators (st, nd, rd, th)
  const cleanedDate = inputDate.replace(/(\d+)(st|nd|rd|th)/, '$1');
  
  // Parse the date
  const date = new Date(cleanedDate);
  
  // Format to YYYY-MM-DD
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}

  const handleConfirmCancel = async () => {
    const inputForStart = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        reason: "abc", // CHANGE IT -> TO an input box
        completed: "2",
        appointmentdate: formatInputDate(visitDate),
        appointmenttime: visitTime,
      },
    };
    try {
      const result = await UpdateAppointmentByDoctor(inputForStart.input);
      cancelVisit.current.closeModal();
      refreshPageContent();
      navigate(`/visits`);
    } catch (error) {
      console.error("Error updating appointment status:", error);
    }
  };

  const handleConfirmAcceptVisit = async () => {
    let input = {
      doctorid: doctorId,
      patientid: patientId,
      appointmentid: appointmentId,
      completed: "1",
    };
    try {
      const result = await AcceptVisit(input);
      // console.log(result);
      // console.log(input);
      if (result != null) {
        acceptVisit.current.closeModal();
        refreshPageContent();
        showSuccessToast("Visit accepted successfully");
      } else {
      }
    } catch (error) {
      acceptVisit.current.closeModal();
      console.error("Error in Visit details accepting visit", error);
    }
  };

  const handleConfirmNoShow = async () => {
    const inputForStart = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        reason: "abc",
        completed: "4",
      },
    };
    try {
      const result = await UpdateAppointmentByDoctor(inputForStart.input);
      noShowVisit.current.closeModal();
      refreshPageContent();
      navigate(`/visits`);
    } catch (error) {
      console.error("Error updating appointment status:", error);
    }
  };

  const handleMessageClick = async () => {
    navigate("/messages", { state: { id: patientId } });
  };

// existing function for printOrder
  // const handlePrintOrder = () => {
  //   const url = `/visitprescription?doctorId=${doctorId}&patientId=${patientId}&appointmentId=${appointmentId}`;
  //   window.open(url, "_blank");
  // };

  // newly added function
const handlePrintOrder = () => {
  if (imagePath && prescriptionUrl) {
    // Concatenate imagePath and prescriptionUrl to form the full URL
    const fullUrl = imagePath + prescriptionUrl;
    window.open(fullUrl, "_blank");
  } else {
    showErrorToast("Prescription not available.");
  }
};

  const handlePrintProgressNotes = () => {
    const url = `/visitsummary?doctorId=${doctorId}&patientId=${patientId}&appointmentId=${appointmentId}`;
    window.open(url, "_blank");
  };

  const handleClick = () => {
    localStorage.setItem("CurrentVisitAppointmentId", appointmentId);
    window.location.href = `/visitdetails?patientId=${patientId}&appointmentId=${appointmentId}`;
  };

  const toggleOptions = (e) => {
    e.stopPropagation();
    setShowOptions(!showOptions);
  };

  useEffect(() => {
    
  setActionAccess(actionAccessMain(2))
  setActionAccessAppointments(actionAccessMain(15))
  setActionAccessMessage(actionAccessMain(3))
  setActionAccessScreening(actionAccessMain(24))
  setActionAccessAssigning(actionAccessMain(25))
    const handleClickOutside = (event) => {
      if (
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        svgRef.current &&
        !svgRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };

    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  // if (borderColor === "green") borderColor = "#14C585";
  // if (borderColor === "blue") borderColor = "#1C4EC5";
  // if (borderColor === "gray") borderColor = "#CDCFD4";
  // if (borderColor === "red") borderColor = "#E82B2B";

    const visitsColor = {
      "complete": {
        "bg": "#eff6ff",  
        "border": "#60a5fa"
      },
      "pending": {
        "bg": "#fffbeb",   
        "border": "#f59e0b"
      },
      "cancelled": {
        "bg": "#ffe4e6",   
        "border": "#e11d48" 
      },
      "noShow": {
        "bg": "#e9e9e9",   
        "border": "gray" 
      },
      "Upcoming": {
        "bg": "#FFFFFF",   
        "border": "#10b981" 
      }
    }

  if (statusName == "Pending") {
    borderColor = visitsColor.pending.border
    bgColor = visitsColor.pending.bg
  } else if (statusName == "Upcoming") {
    borderColor = visitsColor.Upcoming.border
    bgColor = visitsColor.Upcoming.bg
  } else if (statusName == "No-show") {
    borderColor = visitsColor.cancelled.border
    bgColor = visitsColor.cancelled.bg
  } else if(statusName == "Completed"){
    borderColor = visitsColor.complete.border
    bgColor = visitsColor.complete.bg
  } else {
    borderColor = visitsColor.noShow.border
    bgColor = visitsColor.noShow.bg
  }

  const [ShowAssignModal , SetShowAssignModal ] = useState(false)
  const [ShowAssignLogModal , SetShowAssignLogModal ] = useState(false)
  const handleReAssign = async () => {
    SetShowAssignModal(false);
    setTimeout(() => SetShowAssignModal(true), 10);
  }
  const handleReAssignLogs = async () => {
    // setAppointmentIDForAssign(appointmentID)
    SetShowAssignLogModal(false);
    setTimeout(() => SetShowAssignLogModal(true), 10);
  }

  // -----------------------------------------------------------
    // Upcoming Notification Functionality starts
  
    const upcomingNotification = useRef();
  
    const [labDoctor, setLabDoctor] = useState(null);
    const [labBookingStatus, setLabBookingStatus] = useState(null);
    const [labfcmToken, setLabfcmToken] = useState(null);
    const [labName, setLabName] = useState(null);
    const [labPatientId, setLabPatientId] = useState(null);
    const [labDoctorId, setLabDoctorId] = useState(null);
    const [labPatientName, setLabPatientName] = useState(null);
    const [labType, setLabType] = useState(null);
    const [labAppointmentId, setLabAppointmentId] = useState(null);
    const [labDate, setLabDate] = useState(null);
  
    const openUpcomingNotificationData = () => {
      // console.log('patientdetials: ', patientDetails)
      // const formatedDate = formatDate_Do_MMM_YYYY_Time(patientDetails.followupdate)
      // console.log(formatedDate, 'formaterdDated')
  
      // setPa(doctorName)
      // setLabBookingStatus(patientFcm)
      // setLabfcmToken(patientId)
      // setLabName(visitDate)
      // setLabPatientId(visitTime)
      // setLabDoctorId(userName)
      // setLabAppointmentId(appointmentId)
      // setLabPatientName(labDetails.patientname)
      // setLabType(labDetails.entitytype)
      // setFollowupDate(formatedDate)
  
      // sendLabNotification(labDetails)
      upcomingNotification.current.openModal();
    }
  
    const sendUpcomingNotification = async () => {
      const input = [{
      "doctorname": doctorName || "",
      "fcmtoken": patientFcm || "",
      "appointmentdate": visitDate || "",
      "appointmenttime": visitTime || "",
      "doctorid": getLoginID(),
      "orderid": appointmentId || "",
      "patientid": patientId,
      "type": 'appointment',
      "notificationcategoryid": 1,
      "patientname": userName,
      "title": "Upcoming Appointment Reminder",
      "description": `Dear ${userName}, your appointment with Dr. ${doctorName} is scheduled for ${visitDate} at ${visitTime}. Please arrive 10 minutes early. To reschedule, contact the clinic. Thank you!`,
      "branchid": getBranchId(),
      "hospitalid": getHospitalId()
    }];
    //   const input = [{
    //     'doctorname': labDoctor,
    //     'fcmtoken': labfcmToken,
    //     'labname': labName,
    //     'patientid': labPatientId,
    //     'doctorid': labDoctorId,
    //     'patientname': labPatientName,
    //     'type': labType,
    //     'notificationcategoryid': 7,
    //     'orderid': labAppointmentId,
    //     'bookingstatus': labBookingStatus,
    //     "branchid": getBranchId(),
    //     "hospitalid": getHospitalId()
    // }];
      showLoader();
      try {
        const result = await saveAppointmentNotification(input);
        if(result && result.output.result === 'success'){
          showSuccessToast('Notification sent successfully');
          upcomingNotification.current.closeModal();
          // fetchLabsList();
        }else {
          showErrorToast("Something Went Wrong!")
        }
        dismissLoader();
  
      } catch (error) {
        console.error("Error in Sending Upcoming Notification: ", error)
      }
    }
    // Upcoming Notification Functionality ends
  
  // -----------------------------------------------------------
  return (
    <Box
      borderLeft={disableLeftBorder ? "none" : `4px solid ${borderColor}`}
      borderRadius={disableLeftBorder ? "none" : "0.3rem 0 0 0.3rem"}
      position="relative"
    >
      <Box
        bg={bgColor}
        border="1px solid #E6E7E9"
        // borderRadius="0 0.75rem 0.75rem 0"
        borderRadius="0 0.75rem 0 0"
        // borderRadius={isUpcoming && visitStatus !== 'pause' ? '0 0.75rem 0 0' : '0 0.75rem 0.75rem 0' }
        p="1.25rem"
        gap="0.625rem"
        boxShadow="0px 8px 20px 0px #E6E7E966"
        w="100%"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <Box display="flex" gap="0.5rem" w="100%" alignItems="center">
          {userImage ? (
            <Image
              borderRadius="full"
              w="2.75rem"
              h="2.75rem"
              src={userImage}
              objectFit='cover'
            />
          ) : (
            <Image
              borderRadius="full"
              w="2.75rem"
              h="2.75rem"
              src="/assets/imgs/no-image.png"
              objectFit='cover'
            />
          )}
          <Box>
            <Text fontSize="1rem" fontWeight="600" color="#061027">
              {userName}
            </Text>
            <Box display="flex" gap="0.25rem" alignItems="center">
              <Image src="/assets/svgs/home-calendar.svg" />
              <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                {visitDate}, {visitTime}
              </Text>
            </Box>
            <Box display="flex" gap="0.25rem" alignItems="center">
              <Image
                src="/assets/svgs/professional-detail.svg"
                height="16px"
                w="16px"
              />
              <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                {doctorName}
              </Text>
            </Box>
            {isAssign == 1 &&
            <>
            <Box display="flex" gap="0.25rem" alignItems="center">
              <Image
                src="/assets/svgs/green-check.svg"
                height="16px"
                w="16px"
              />
              <Text fontSize="0.75rem" fontWeight="600" color="#384052">
                {isAssign == 1 ? "Assigned to you" : ""}
              </Text>
            </Box>
            
             <Box display="flex" pos='absolute' top='0' right='0' p='5px 10px' borderRadius='0 10px 0 10px' bg='rgb(255, 229, 154)' gap="0.25rem" alignItems="center">
             <Text fontSize="0.75rem" fontWeight="600" color="rgb(247, 128, 3)">
               {isAssignStatus}
             </Text>
           </Box>
           </>
            }
          </Box>
          <Spacer />
          <Box
            ref={svgRef}
            position="relative"
            onClick={toggleOptions}
            height="2rem"
            display="flex"
            alignItems="center"
          >
            <Image src="/assets/svgs/more-options.svg" />
          </Box>
        </Box>
        {issue && (
          <Box mt="0.75rem">
            <Text fontSize="0.875rem" fontWeight="500" color="#384052">
              {issue}
            </Text>
          </Box>
        )}
      </Box>
      {appointmentStatus == 1 ? (
        <PrimaryButton
          // buttonText="Start visit"
          buttonText={visitStatus !== "pause" ? "Start Visit" : "Resume Visit"}
          variant="grayBtn"
          btnStyle={{
            w: "100%",
            color: "#061027",
            borderRadius: "0 0 10px 0",
            boxShadow:
              "0px 0px 0px 1px #E6E7E94D, 0px 1px 2px 0px #C1C2C680, 0px -8px 12px 0px #D8D8D833 inset",
          }}
          onClick={() => startVisit.current.openModal()}
          isDisabled={
            actionAccessAppointments && actionAccessAppointments.create
              ? false
              : true
          }
        />
      ) : appointmentStatus == 3 ? (
        <PrimaryButton
          buttonText="View Prescription"
          variant="grayBtn"
          btnStyle={{
            w: "100%",
            color: "#061027",
            borderRadius: "0 0 10px 0",
            boxShadow:
              "0px 0px 0px 1px #E6E7E94D, 0px 1px 2px 0px #C1C2C680, 0px -8px 12px 0px #D8D8D833 inset",
          }}
          onClick={handlePrintOrder}
          // onClick={imagePath && prescriptionUrl && window.open(imagePath + prescriptionUrl, "_blank")}
          isDisabled={
            actionAccessAppointments && actionAccessAppointments.create
              ? false
              : true
          }
        />
      ) : appointmentStatus == 4 && (
          <PrimaryButton
            buttonText="Re-Schedule"
            variant="grayBtn"
            btnStyle={{
              w: "100%",
              color: "#061027",
              borderRadius: "0 0 10px 0",
              boxShadow:
                "0px 0px 0px 1px #E6E7E94D, 0px 1px 2px 0px #C1C2C680, 0px -8px 12px 0px #D8D8D833 inset",
            }}
            onClick={openRescheduleModal}
            isDisabled={
              actionAccessAppointments && actionAccessAppointments.create
                ? false
                : true
            }
          />
      )}

      {showOptions && (
        <Box
          ref={optionsRef}
          position="absolute"
          top="3rem"
          right="1rem"
          bg="white"
          boxShadow="md"
          borderRadius="md"
          zIndex="10"
        >
          <VStack align="stretch" spacing="0">
            {isNotUpcoming ? (
              <>
                {isFinished && (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    onClick={handlePrintOrder}
                  >
                    Print Prescription
                  </Button>
                )}

                {isFinished && (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    onClick={handlePrintProgressNotes}
                  >
                    Print Progress Notes
                  </Button>
                )}

                <Button
                  variant="ghost"
                  textAlign="left"
                  justifyContent="flex-start"
                  onClick={handleMessageClick}
                  isDisabled={
                    actionAccessMessage &&
                    (!actionAccessMessage.create || !actionAccessMessage.update)
                      ? true
                      : false
                  }
                >
                  Message patient
                </Button>
                <Button
                  variant="ghost"
                  textAlign="left"
                  justifyContent="flex-start"
                  onClick={openScheduleModal}
                  isDisabled={
                    actionAccess && !actionAccess.create ? true : false
                  }
                >
                  Schedule visit
                </Button>
              </>
            ) : (
              <>
                {statusName !== "Pending" ? (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    onClick={() => startVisit.current.openModal()}
                    isDisabled={
                      actionAccessAppointments &&
                      actionAccessAppointments.create
                        ? false
                        : true
                    }
                  >
                    {visitStatus === "pause" ? "Resume visit" : "Start visit"}
                  </Button>
                ) : (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    onClick={() => acceptVisit.current.openModal()}
                    isDisabled={
                      actionAccess && actionAccess.create ? false : true
                    }
                  >
                    {"Accept Visit"}
                  </Button>
                )}
                {statusName === "Pending" && (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    // onClick={() => noShowVisit.current.openModal()}
                    // onClick={() => openUpcomingNotificationData()}
                    isDisabled={
                      actionAccess && !actionAccess.update ? true : false
                    }
                  >
                    Send Notification
                  </Button>
                )}
                {(isUpcoming || statusName === "Upcoming") && (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    // onClick={() => noShowVisit.current.openModal()}
                    onClick={() => openUpcomingNotificationData()}
                    isDisabled={
                      actionAccess && !actionAccess.update ? true : false
                    }
                  >
                    Send Notification
                  </Button>
                )}
                {statusName === "Upcoming" && visitStatus !== "pause" && (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    onClick={handleCreateVisitClick}
                    isDisabled={
                      actionAccessScreening && actionAccessScreening.create
                        ? false
                        : true
                    }
                  >
                    Advanced details
                  </Button>
                )}
                <Button
                  variant="ghost"
                  textAlign="left"
                  justifyContent="flex-start"
                  onClick={() => handleReAssign()}
                  isDisabled={actionAccessAssigning && actionAccessAssigning.create ? false : true}
                                         
                >
                  Assign Appointment
              </Button> 
              <Button
                  variant="ghost"
                  textAlign="left"
                  justifyContent="flex-start"
                  onClick={() => handleReAssignLogs()}
                  isDisabled={actionAccessAssigning && actionAccessAssigning.create ? false : true}
                                         
                >
                  Assign History Logs 
              </Button> 
                <Button
                  variant="ghost"
                  textAlign="left"
                  justifyContent="flex-start"
                  onClick={handleMessageClick}
                  isDisabled={
                    actionAccessMessage &&
                    (!actionAccessMessage.create || !actionAccessMessage.update)
                      ? true
                      : false
                  }
                >
                  Message patient
                </Button>
                <Button
                  variant="ghost"
                  textAlign="left"
                  justifyContent="flex-start"
                  onClick={openRescheduleModal}
                  isDisabled={
                    actionAccess && !actionAccess.update ? true : false
                  }
                >
                  Reschedule visit
                </Button>
                <Button
                  variant="ghost"
                  textAlign="left"
                  justifyContent="flex-start"
                  onClick={() => cancelVisit.current.openModal()}
                  isDisabled={
                    actionAccess && !actionAccess.delete ? true : false
                  }
                >
                  Cancel visit
                </Button>
                {isUpcoming && (
                  <Button
                    variant="ghost"
                    textAlign="left"
                    justifyContent="flex-start"
                    onClick={() => noShowVisit.current.openModal()}
                    isDisabled={
                      actionAccess && !actionAccess.update ? true : false
                    }
                  >
                    Mark patient as no-show
                  </Button>
                )}
              </>
            )}
          </VStack>
        </Box>
      )}

      {/* Start Visit  */}
      <DynamicModal
        ref={startVisit}
        modalHeader={visitStatus === "pause" ? "Resume visit" : "Start visit"}
        modalBody={
          <>
            <Box>
              <Text fontSize="0.87rem" fontWeight="400">
                {visitStatus === "pause"
                  ? "Are you sure you want to resume this visit now?"
                  : "Are you sure you want to start this visit now?"}
              </Text>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText={
                visitStatus === "pause" ? "Resume visit" : "Start visit"
              }
              onClick={handleConfirmStart}
            />
          </>
        }
      />

      {/* Start Visit  */}
      <DynamicModal
        ref={acceptVisit}
        modalHeader={"Accept Visit"}
        modalBody={
          <>
            <Box>
              <Text fontSize="0.87rem" fontWeight="400">
                Are you sure you want to accept this visit?
              </Text>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText={"Accept Visit"}
              onClick={handleConfirmAcceptVisit}
            />
          </>
        }
      />

      {/* Schedule Visit  */}
      <DynamicModal
        ref={scheduleVisit}
        modalHeader="Schedule Visit"
        modalWidth="40%"
        modalBody={
          <>
            <Box>
              <Box mt={"8px"}>
                <DatePicker
                  defaultDate={moment(new Date()).format("DD-MM-YYYY")}
                  minDate={moment(new Date()).format("DD-MM-YYYY")}
                  // disableFutureDates={false}
                  onDateChange={(selectedDateValue) => {
                    setAppointmentScheduleDate(selectedDateValue);
                    fetchDoctorScheduleSlots(selectedDateValue);
                  }}
                  placeholderProp={"Select Date"}
                  calendarStlye={{ left: "-18px", right: "unset" }}
                />
                <NewScheduleSlotSelector availableSlots={availableSlots} />
              </Box>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="grayBtn"
              buttonText="Schedule"
              // onClick={() => scheduleVisit.current.closeModal()}
              onClick={handleScheduleClick}
              btnStyle={{
                h: "2.5rem",
                w: "100%",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            />
          </>
        }
      />

      {/* Reschedule Visit  */}
      <DynamicModal
        ref={rescheduleVisit}
        modalHeader="Reschedule Visit"
        modalWidth="40%"
        modalBody={
          <>
            <Box>
              <Text fontSize='0.95rem'>
                {/* {"Your appointment is currently scheduled on" + <b>{visitDate}</b> + " at " + <b>{visitTime}</b> + ". Please select a new date and time if you wish to reschedule."} */}
                <>
  Your appointment is currently scheduled on <b>{visitDate}</b> at <b>{visitTime}</b>. Please select a new date and time if you wish to reschedule.
</>
              </Text>
              <Box mt={"8px"}>
                <DatePicker
                  defaultDate={moment(new Date()).format("DD-MM-YYYY")}
                  minDate={moment(new Date()).format("DD-MM-YYYY")}
                  // disableFutureDates={false}
                  onDateChange={(selectedDateValue) => {
                    setAppointmentRescheduleDate(selectedDateValue);
                    fetchDoctorSlots(selectedDateValue);
                  }}
                  placeholderProp={"Select Date"}
                  calendarStlye={{ left: "-18px", right: "unset" }}
                />
                <NewSlotSelector availableSlots={availableSlots} />
              </Box>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="grayBtn"
              buttonText="Reschedule"
              // onClick={() => rescheduleVisit.current.closeModal()}
              onClick={handleRescheduleClick}
              btnStyle={{
                h: "2.5rem",
                w: "100%",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            />
          </>
        }
      />

      {/* Mark as No Show Visit  */}
      <DynamicModal
        ref={noShowVisit}
        modalHeader="Mark as No Show"
        modalBody={
          <>
            <Box>
              <Text fontSize="0.87rem" fontWeight="400">
                Are you sure you want to mark as no-show for your visit with{" "}
                <Box as="span" fontWeight="500">
                  {userName}
                </Box>{" "}
                scheduled on{" "}
                <Box as="span" fontWeight="500">
                  {visitDate} at {visitTime}?
                </Box>
              </Text>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Mark as no-show"
              onClick={handleConfirmNoShow}
            />
          </>
        }
      />

      {/* Mark as cancel Visit  */}
      <DynamicModal
        ref={cancelVisit}
        modalHeader="Cancel visit"
        modalBody={
          <>
            <Box>
              <Text fontSize="0.87rem" fontWeight="400">
                Are you sure you want to cancel your visit with{" "}
                <Box as="span" fontWeight="500">
                  {userName}
                </Box>{" "}
                scheduled on{" "}
                <Box as="span" fontWeight="500">
                  {visitDate} at {visitTime}?
                </Box>
              </Text>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Cancel visit"
              onClick={handleConfirmCancel}
            />
          </>
        }
      />

      {/* Send Notification */}
      <DynamicModal
              ref={upcomingNotification}
              modalHeader="Upcoming Notification?"
              modalBody={
                <>
                  <Text fontSize="14px" fontWeight="600">
                  {/* {`Are you sure you want to send Notification to ?`} */}
                  {`Are you sure you want to send Notification to "${userName}"?`}
                  </Text>
                </>
              }
              modalFooterBtn={
                <>
                  <PrimaryButton
                    // variant="deleteBtn"
                    buttonText="Send"
                    onClick={sendUpcomingNotification}
                  />
                </>
              }
            />

        {/* Assign Modal  */}
        {ShowAssignModal &&<AssignVisit appointmentId={appointmentId}/>}  
        {ShowAssignLogModal &&<AssignVisitLogs appointmentId={appointmentId}/>}
        </Box>
  );
};

export default PatientVisitCard;
